import { DrmPage } from 'v2/models';
import useFieldMutation from './useFieldMutation';
import { toast } from 'react-toastify';
import { capitalize } from 'lodash';
import { useDrmPageToParams } from '../models';

type Entity = Record<string, unknown>;

interface useFieldMutationProps {
  fieldName: string;
  fieldLabel: string;
  drmPage: DrmPage;
  entity: Entity;
  onUpdate: (entity: Entity) => void;
  onClose: () => void;
}

export default function useFormFieldMutation({
  fieldName,
  fieldLabel,
  drmPage,
  entity,
  onUpdate,
  onClose,
}: useFieldMutationProps) {
  const drmPageToParams = useDrmPageToParams();
  const { entityName } = drmPageToParams[drmPage];

  const mutation = useFieldMutation({
    fieldName,
    entity,
    drmPage,
    onUpdate,
    onSuccess: () => {
      const message = `${capitalize(entityName)} ${fieldLabel} saved.`;
      toast.success(message);
      onClose();
    },
    onError: () => {
      toast.error(`Error saving ${entityName} ${fieldLabel}.`);
    },
  });

  return mutation;
}
